import _ from "lodash";

export function headerTitleToId(title: string): string {
  return _.kebabCase(title);
}
